<ngx-spinner bdColor="rgba(51,51,51,0.55)"
        size="medium"
        color="#fff"
        type="line-spin-clockwise-fade"
        [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'general.manage_user_groups' | translate}}  - {{_userName}}</h4>
    <button type="button" class="close" (click)="activeModal.close()">&times;</button>
</div>
<div class="modal-body">
    <div class="container">
        <div *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']">
            <div *ngIf="_status!=0&&_status<4">
            <h3 class="mb-2">{{'setting.groups' | translate}}</h3><br>
            <span>{{'setting.add_group' | translate}}<span class="error">*</span></span>
            <div class="row mt-1">
                <div class="col-6">
                    <ng-multiselect-dropdown 
                        tabindex="0"
                        placeholder="{{'general.select' | translate}}"
                        [data]="dropdownList"
                        [(ngModel)]="selectedItems"
                        [settings]="dropdownSettings"
                        (onSelect)="onItemSelect($event)"
                        (onSelectAll)="onSelectAll($event)"
                        (onDeSelect)="onItemDeSelect($event)"
                        (onDeSelectAll)="onDeSelectAll($event)"
                        
                    >   
                    </ng-multiselect-dropdown>
                    <div class="error" id="error"></div>
                </div>
                <div class="col-6">
                    <button type="button" class="btn btn-green btn-h-green" title="{{'general.add' | translate}}" (click)="saveSelectedGroups()">
                        {{'general.add' | translate}}
                    </button>
                </div>
            </div>
            <hr>
            </div>
        </div>

        <div class="col-12 p-0"> 
            <h3>{{'profile.group_list' | translate}}</h3>
            <table mat-table [dataSource]="dataSource" matSort matSortActive="tagName" matSortDirection="asc" matSortDisableClear>
                <ng-container matColumnDef="tagName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'general.name' | translate}} </th>
                    <td mat-cell *matCellDef="let group"> {{group.tagName}} </td>
                </ng-container> 
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef [attr.role]="null" scope="col"> {{'general.actions' | translate}} </th>
                    <td mat-cell *matCellDef="let group" [attr.role]="null">
                        <a tabindex="0" class="custom-hyperlink" (keydown.enter)="deleteGroup(group.tagId)" (click)="deleteGroup(group.tagId)" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']"><i class="fa fa-trash"></i> {{'general.delete' | translate}}</a>
                        <div *ngxPermissionsOnly="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']">-</div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns" [attr.role]="null"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" [attr.role]="null"></tr>
            </table>
            <mat-paginator #paginator [pageSizeOptions]="[5]" [length]="totalLength" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>